/* MUI */
import { Box, Typography } from '@mui/material';

/* React */
import React from 'react';
import { useTranslation } from 'react-i18next';

/* Internal Components */
import { ContractSectionTitle } from './ContractSectionTitle';
import { UserDetailsAppInfo } from './UserDetailsAppInfo';

export const ContractUsersDetailsAppBreakdown = ({ contracts }) => {
    const { t } = useTranslation();

    return (
        <Box
            data-testid="contractUsersDetailsAppBreakdown"
            sx={{
                backgroundColor:
                    contracts.length > 0
                        ? 'background.contractTable'
                        : 'background.contractTableLight'
            }}
            pb="24px"
            className="break-before"
        >
            <Box
                px="24px"
                sx={{ backgroundColor: 'background.contractsReport' }}
            >
                <ContractSectionTitle
                    title={t('Reports.Contracts.usersDetails')}
                    subtitle={t('Reports.Contracts.usersDetailsAppBreakdown')}
                />
            </Box>
            {!(contracts.length > 0) ? (
                <Box
                    data-testid="contractUsersDetailsAppBreakdownNoContracts"
                    px="24px"
                    sx={{ backgroundColor: 'background.white' }}
                >
                    <Typography variant="body2">
                        {t('Reports.Contracts.noEventMatch')}
                    </Typography>
                </Box>
            ) : (
                contracts.map((contract) => (
                    <Box
                        data-testid="contractUsersDetailsAppBreakdownSingleContract"
                        mt="0"
                        key={`contractUsersDetailsAppBreakdown_${contract.applicationId}`}
                    >
                        <UserDetailsAppInfo contract={contract} t={t} />
                    </Box>
                ))
            )}
        </Box>
    );
};
